import { render, staticRenderFns } from "./AdministradorProfile.vue?vue&type=template&id=f2543636"
import script from "./AdministradorProfile.vue?vue&type=script&lang=js"
export * from "./AdministradorProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports